module.exports = {
    initGridContainer: function() {
        const $customProductTileElem = $('.marykay-custom-product-tile-component');

        if($customProductTileElem.length > 0) {
            $customProductTileElem.each(function (idx, productTile) {
                $(productTile).closest('.region').addClass('region-grid');
            });
        }
    }
};
